export { default } from "./Residents";

export const BASE_RESIDENTS_PATH = "residents";

export const RESIDENTS_ROUTES = {
  RESIDENT: "resident",
  REVIEW: "review",
};
